<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-3">
        <h5>組織変更</h5>
      </div>
      <div class="col-5">
        <button type="button" class="createBtn btn-sm btn-outline-info" v-on:click="back">中断する</button>
        <button type="button" class="createBtn btn-sm btn-outline-info" v-on:click="create">組織を追加する</button>      
        <button type="button" class="createBtn btn-sm btn-outline-info" v-on:click="copy">現状の組織を複製する</button>
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <table class="table table-dark table-sm table-hover table-borderless">
          <thead>
            <tr>
              <th scope="col" style="width:70px">#</th>
              <th scope="col">組織名称</th>
              <th scope="col" style="width:150px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(organization, index) in organizations" v-bind:key="organization.id">
              <th scope="row">{{ index + 1 }}</th>
              <td>{{ organization.displayName }}</td>
              <td>
                <button type="button" class="btn-sm btn-light" v-on:click="modify(organization.id)">編集する</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-3">
      </div>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <button type="button" class="btn btn-info btn btn-block" v-on:click="next">次へ</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'OrgList',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      organizations: [],
      message: '',
      space: '　'
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.search()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search()
        }
      }
    )
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    copy() {
      var reserveId = this.$route.params.reserveid;
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        axios.post("/api/organization/management/reserve/copy", {
          hospitalId: hospitalId,
          reserveId: reserveId
        },{
          headers: this.headers(accessToken)
        }).then((response) => {
          var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('複製しました。')
              this.search(true)
            }
        }).catch(err => {
          this.message = err.message
        })
      } else {
       this.$router.replace('/login') 
      }}).catch((err) => {
        this.message = err.message
      })

    },
    create() {
      var reserveId = this.$route.params.reserveid;
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/orgcreate/'+reserveId))
    },
    modify(id) {
      var reserveId = this.$route.params.reserveid;
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/orgmodify/'+reserveId+'/'+id))
    },
    search() {
      var reserveId = this.$route.params.reserveid;
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        axios.post("/api/organization/management/reserve/list", {
          hospitalId: hospitalId,
          historyId: reserveId
        },{
          headers: this.headers(accessToken)
        }).then(response => {
          this.organizations = response.data.data.organizations.map(element => {
            var name = element.organizationName
            element.displayName = this.space.repeat(element.hierarchyNo) + name
            return element
          })
        }).catch(err => {
          this.message = err.message
        })
      } else {
       this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login')) 
      }}).catch((err) => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/index'))
    },
    next() {
      var reserveId = this.$route.params.reserveid;
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/belonglist/'+reserveId+'/'+reserveId))
    },

  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
.createBtn {
  float:right;
}
.btn-sm{
  margin-left: 5px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.sort-solid{
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
#sort-select{
  width: 70%;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>